import React, { useEffect } from "react";
import Checkbox from "../../Input/Checkbox";
import useCheckedItems from "./hooks/useCheckedItems";
import useHandleChange from "./hooks/useHandleChange";
import { BaseCheckboxListContainer } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function CheckboxList(_ref) {
  var _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return [];
    } : _ref$onChange,
    options = _ref.options,
    direction = _ref.direction,
    value = _ref.value,
    checkboxListName = _ref.name,
    ariaLabelledBy = _ref.ariaLabelledBy,
    disabled = _ref.disabled;
  var _useCheckedItems = useCheckedItems(value),
    checkedItems = _useCheckedItems.checkedItems,
    setCheckedItems = _useCheckedItems.setCheckedItems;
  var handleChange = useHandleChange(checkedItems, setCheckedItems);
  useEffect(function () {
    onChange(checkedItems);
  }, [checkedItems, onChange]);
  return /*#__PURE__*/_jsx(BaseCheckboxListContainer, {
    role: "group",
    direction: direction,
    "aria-labelledby": ariaLabelledBy,
    children: options === null || options === void 0 ? void 0 : options.map(function (_ref2) {
      var label = _ref2.label,
        id = _ref2.id,
        optionValue = _ref2.value,
        name = _ref2.name,
        optionDisabled = _ref2.disabled;
      return /*#__PURE__*/_jsx(Checkbox, {
        disabled: disabled || optionDisabled,
        label: label,
        id: id,
        value: optionValue,
        checked: checkedItems.includes(optionValue),
        onChange: function onChange() {
          return handleChange(optionValue);
        }
        /**
         * In checkbox groups, the `name` field should be the same across all checkboxes
         * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#handling_multiple_checkboxes
         *
         * We use the `name` prop passed to the CheckboxList, but still allow the user to set a `name` on a per-Checkbox basis if need be via each item passed to the `options` array.
         * */,
        name: name || checkboxListName
      }, optionValue);
    })
  });
}
export default CheckboxList;